import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
// import { PdfReader } from "../../utils/DocumentViewer";
import { ViewLeasePdfReader } from "../../utils/ViewLeaseDocumentViewer";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
class UploadDocuments extends React.Component {
  state = {
    showUploadDocument: false,
    fileName: "",
    documentType: "",
    uploadedDocuments: [],
    currentDocument: "",
    pageNo: 1,
    documentTable: [],
    documentNamesAfterAdd: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      uploadedDocs: this.props.uploadedDocs,
    };
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  render() {
    return (
      <div className="tabHolder outsideAccordian mb-4 detailswithTwoLabels">
        <div className="row tabForm">
          {this.state.uploadedDocs != null &&
            this.state.uploadedDocs.map(function (name, index) {
              return (
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Document Type <span className="astrik">*</span>
                          </label>
                          {/* <label className="col-sm-7 col-form-label">
                          {name.leaseDocumentType}
                        </label> */}
                          <label className="col-sm-7 col-form-label">
                            <a
                              style={{ width: "607px" }}
                              href="javascript:void(0)"
                              className="clauseNameLink"
                              onClick={(e) => {
                                e.preventDefault();
                                this.state.currentDocument = name.url;
                                this.state.pageNo = 1;
                                //this.openModal();
                                if(name.url != "" && name.uploadDocType != "xls") {
                                  this.openModal(); 
                                }else{
                                  window.location.href = name.url;
                                }
                              }}
                            >
                              {name.leaseDocumentType}
                            </a>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Document Date<span className="astrik">*</span>
                          </label>
                          <label className="col-sm-7 col-form-label">
                            {leaseDateFormat(name.leaseUploadDocumentDate)}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }, this)}
        </div>
        <div className="row">
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpen}
              onHide={this.closeModal}
              size="lg"
              className="documentModal"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <div className="container modalBreadCrumbs">
                    <div className="row">
                      <div className="col-lg-12">
                        <ul>
                          <li>Document</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="container">
                  <div className="row">
                    <ViewLeasePdfReader
                      url={this.state.currentDocument}
                      pageNumber={this.state.pageNo}
                    />
                  </div>
                </div>
              </Modal.Body>
              {/* <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={this.closeModal}
                  >
                    Close
                  </Button>
                </Modal.Footer> */}
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(UploadDocuments);
